/* eslint-disable react/no-unknown-property */
import { useRef, useCallback } from "react";
import * as THREE from "three";
import { ThreeEvent } from "@react-three/fiber";

interface GroundPlaneProps {
  onClickGround: (point: THREE.Vector3) => void;
}

const MAX_CLICK_DURATION = 200; // ms
const MAX_CLICK_DISTANCE = 5; // px

export default function GroundPlane({ onClickGround }: GroundPlaneProps) {
  const pointerDownTime = useRef(0);
  const pointerDownPos = useRef({ x: 0, y: 0 });

  const handlePointerDown = useCallback((e: ThreeEvent<PointerEvent>) => {
    pointerDownTime.current = Date.now();
    pointerDownPos.current = { x: e.nativeEvent.clientX, y: e.nativeEvent.clientY };
  }, []);

  const handlePointerUp = useCallback(
    (e: ThreeEvent<PointerEvent>) => {
      const elapsed = Date.now() - pointerDownTime.current;
      const dx = e.nativeEvent.clientX - pointerDownPos.current.x;
      const dy = e.nativeEvent.clientY - pointerDownPos.current.y;
      const distance = Math.sqrt(dx * dx + dy * dy);

      // Only treat as click if it was quick and didn't move much (not a drag/pan)
      if (elapsed < MAX_CLICK_DURATION && distance < MAX_CLICK_DISTANCE) {
        e.stopPropagation();
        onClickGround(e.point);
      }
    },
    [onClickGround]
  );

  return (
    <mesh
      rotation={[-Math.PI / 2, 0, 0]}
      position={[0, 0.001, 0]}
      onPointerDown={handlePointerDown}
      onPointerUp={handlePointerUp}
    >
      <planeGeometry args={[200, 200]} />
      <meshBasicMaterial transparent opacity={0} side={THREE.DoubleSide} />
    </mesh>
  );
}
